import { Converter } from '@app/shared/utils/converter';
import { DateInputFormatPlaceholder } from '@progress/kendo-angular-dateinputs';

export class DateFormatStore {
  private static _userDateFormat: string | null;
  private static _roomDateFormat: string | null;

  private static getDateToken(regExp: RegExp, fallback: string): string {
    return this.dateFormat.match(regExp)?.[0] || fallback;
  }

  static get dateFormat(): string {
    return this._userDateFormat || this._roomDateFormat || Converter.DateAndTime.MAIN_DATE_FORMAT;
  }

  // TODO: temporary solution because of bug in kendo-datepicker https://github.com/telerik/kendo-angular/issues/4603
  static get dateFormatTemporary(): string {
    return this._userDateFormat || this._roomDateFormat || 'DD MM YYYY';
  }

  static get dateTimeFormat(): string {
    return DateFormatStore.dateFormat + ' HH:mm:ss';
  }

  static get dateTimeNoSecondsFormat(): string {
    return DateFormatStore.dateFormat + ' HH:mm';
  }

  static get luxonDateTimeFormat(): string {
    return this.dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y');
  }

  static get luxonDateTimeFormatWithTime(): string {
    return this.dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y') + ' HH:mm:ss';
  }

  static set userDateFormat(format: string) {
    this._userDateFormat = format;
  }

  static clearUserDateFormat(): void {
    this._userDateFormat = null;
  }

  static set roomDateFormat(format: string) {
    this._roomDateFormat = format;
  }

  static clearRoomDateFormat(): void {
    this._roomDateFormat = null;
  }

  static get getFormatPlaceholder(): DateInputFormatPlaceholder {
    return {
      day: this.getDateToken(/D+/, 'DD'),
      month: this.getDateToken(/M+/, 'MM'),
      year: this.getDateToken(/Y+/, 'YYYY'),
      hour: 'HH',
      minute: 'mm',
      second: 'ss',
    };
  }
}
